$('#footer-reclamation').ready(function () {
    if ($('#filter').length) {
        $("select#filter").change(function () {
            $(".contrat").hide();
            $("#"+$(this).val()).show();
        })
    }
});